module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "online-users"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    attrs: {
      "id": "online-users-list"
    }
  }, _vm._l((_vm.onlineUsers), function(user) {
    return _c('a', {
      key: user.id,
      attrs: {
        "href": ("/Profile/" + (user.stringUrl)),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.avatarImage(user)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.alias))])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-fw fa-sun-o"
  }), _vm._v(" Online Users")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28625847"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Chatroom/ChatSidePanelWidgets/OnlineUsers.vue
// module id = 392
// module chunks = 1